import React from "react";
import ReactSVG from "react-svg";
import { Grid } from "@material-ui/core";
import { Margin, Text } from "~/components/elements";
import { HashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";
import LogoPromoFooter from "~/assets/img/icon/logo-brand.svg";

import Mail from "~/assets/img/icon/mail.svg";
import Phone from "~/assets/img/icon/phone.svg";

import * as S from "./styles";

import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

export default function Footer() {
  const mobile = isMobile();
  const location = useLocation();
  const goTo = (address) => {
    history.push({ pathname: address, search: location.search });
  };
  return (
    <S.BgFooter id="footer">
      {mobile && (
        <Margin pt={6} mb={3}>
          <Grid container spacing={3} justifyContent="center">
            <Grid item>
              <a
                href="https://www.facebook.com/johnsonsbabybrasil?ref=hl"
                rel="noopener noreferrer"
                target="_blank"
              >
                <S.FBButton />
              </a>
            </Grid>
            <Grid item>
              <a
                href="https://www.instagram.com/jbabybr/"
                rel="noopener noreferrer"
                target="_blank"
              >
                <S.IGButton />
              </a>
            </Grid>
            <Grid item>
              <a
                href="https://www.youtube.com/channel/UCz6iuMEiLrq0c-60R7D7LqQ"
                rel="noopener noreferrer"
                target="_blank"
              >
                <S.YTButton />
              </a>
            </Grid>
          </Grid>
        </Margin>
      )}
      <Margin pt={mobile ? 0 : 6} mb={mobile? 8 : 4}>
        <Grid container justifyContent={mobile ? "center" : "flex-start"}>
          <S.SVGHolder onClick={() => goTo("/")}>
            <ReactSVG src={LogoPromoFooter} />
          </S.SVGHolder>
        </Grid>
      </Margin>
      
      {!mobile && (
        <Grid container>
          <S.Border2 />
        </Grid>
      )}

      <Margin mb={1}>
        <Grid container justifyContent="space-between" alignItems="center">
          <S.LinksHolder>
              <a
                href="https://www.johnsonsbaby.com.br/politica-de-privacidade"
                rel="noopener noreferrer"
                target="_blank"
              >
              <Text
                level={mobile ? "2" : "3"}
                as="anchor"
                id="privacyLinkFooter"
              >
                Política de Privacidade
              </Text>
            </a>
            <HashLink smooth to="/informacoes-legais#conteudo">
              <Text level={mobile ? "2" : "3"} as="anchor" id="legalLinkFooter">
                Informações Legais
              </Text>
            </HashLink>
            <HashLink smooth to="/regulamento#conteudo">
              <Text level={mobile ? "2" : "3"} as="anchor" id="legalLinkFooter">
                Regulamento
              </Text>
            </HashLink>
            {/* <a
              href="https://www.semprelivre.com.br/fale-conosco-landing"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Text level={mobile ? "2" : "3"} as="anchor">
                Fale Conosco
              </Text>
            </a> */}
            {/* <HashLink smooth to="/premios#conteudo">
              <Text level={mobile ? "2" : "3"} as="anchor">
                Prêmios
              </Text>
            </HashLink> */}
          </S.LinksHolder>
          {!mobile && (
            <S.SocialHolder>
              <a
                href="https://www.facebook.com/johnsonsbabybrasil?ref=hl"
                rel="noopener noreferrer"
                target="_blank"
              >
                <S.FBButton />
              </a>
              <a
                href="https://www.instagram.com/jbabybr/"
                rel="noopener noreferrer"
                target="_blank"
              >
                <S.IGButton />
              </a>
              <a
                href="https://www.youtube.com/channel/UCz6iuMEiLrq0c-60R7D7LqQ"
                rel="noopener noreferrer"
                target="_blank"
              >
                <S.YTButton />
              </a>
            </S.SocialHolder>
          )}
          <S.Border2 />
        </Grid>
      </Margin>

      <Margin mb={0}>
        <Grid container alignItems="flex-start">
          <S.Contact>
            <Margin mb={mobile ? 2 : 0}>
              <Text className="title" as="strong">
                Fale conosco
              </Text>
            </Margin>

            <S.FooterContact>
              <S.FooterContactItem>
                <ReactSVG src={Mail} />
                <Text>
                  <strong>
                    <a
                      href="mailto: promocoeskenvue@holdingclube.com.br"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      promocoeskenvue@holdingclube.com.br{" "}
                    </a>
                  </strong>
                </Text>
              </S.FooterContactItem>
              <S.FooterContactItem>
                <ReactSVG src={Phone} />
                <Text>
                  <a
                    href="tel: 0800 285 6213"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <strong>0800 285 6213 </strong>{" "}
                  </a>
                  - Segunda à sexta-feira, exceto feriados, das 9h às 17h.
                </Text>
              </S.FooterContactItem>
            </S.FooterContact>
          </S.Contact>
          <S.Border2 />
        </Grid>
      </Margin>

      <Margin mb={1}>
        <Grid container>
          <S.Disclaimer>
            <Margin mb={1}>
              <Text>
                Promoção válida para maiores de 18 anos e bebês de zero a três anos. Período de participação: de 10/04/2025 até as 15h (horário de Brasília) ao dia 09/06/2025. Consulte os produtos participantes, o regulamento completo e o Certiﬁcado de Autorização SPA/MF no site www.promo.johnsonsbaby.com.br antes de participar. *Consulte as condições de se tornar a nova estrela da marca no regulamento da promoção. **O prêmio será entregue em Certiﬁcado em Barras de Ouro. Imagens meramente ilustrativas.
              </Text>
            </Margin>
            <Text>
              Este website ("Website") é fornecido a você mediante estes{" "}
              <HashLink smooth to="/informacoes-legais#conteudo">
                "Termos de Uso"
              </HashLink>, {" "}
              bem como quaisquer alterações ou complementos a eles (coletivamente denominados "Contrato") que poderão ser publicados por ©JNTL Consumer Health (Brazil) Ltda ou uma de suas empresas afiliadas (coletivamente, “Proprietário do Site,” "nós", "nos") de tempos em tempos. Seu uso deste Website ou de quaisquer serviços ou conteúdo previsto por meio do Website [ou do Software Móvel] será considerado a constituir seu consentimento em legalmente se obrigar pelos termos e condições do Contrato, que serão exequíveis da mesma maneira como se você tivesse assinado o Contrato. Caso não deseje aceitar os termos e condições no Contrato, pedimos que você não acesse ou utilize o Website ou divulgue ou envie quaisquer materiais a respeito dele. 
            </Text>
          </S.Disclaimer>
        </Grid>
      </Margin>
      <Margin pb={mobile ? 6 : 8}>
        <Grid container>
          <Text level="3">
            <strong>
              Este site contém links para websites para os quais a nossa{" "}
              <a
                href="https://www.johnsonsbaby.com.br/politica-de-privacidade"
                rel="noopener noreferrer"
                target="_blank"
              >
                Política de Privacidade
              </a>{" "}
              não se aplica. Nós o incentivamos a ler a política de privacidade
              para cada site que visitar.
            </strong>
          </Text>
        </Grid>
      </Margin>
    </S.BgFooter>
  );
}
